export class SubscriberBillingContactInformationModel {
	phone: string = '';
	cellPhone: string = '';
	emails: string[] = [];
	emailsStringified: string = '';

	constructor(s?: Partial<SubscriberBillingContactInformationModel>) {
		Object.assign(this, s)

		this._parseEmails()
	}

	normalize():Partial<SubscriberBillingContactInformationModel> {
		return {
			phone: this.phone || "",
			cellPhone: this.cellPhone || "",
			emails: this.emailsStringified ? this.emailsStringified.split(',').map((email) => email.trim()).filter((email) => !!email) : [],
		}
	}

	hasEmails(): boolean {
		return !!this.emailsStringified
	}

	isValid(): boolean {
		return this.hasEmails()
	}

	private _parseEmails():void {
		this.emailsStringified = this.emails.join(',')
	}
}
